export default function nassauReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_NASSAU":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
